import Input from "../components/common/Input";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import { fetch2fa, fetchLogin } from "./FetchAuth";
import { updateUserInfo } from "../store/actions/userAction";
import { useDispatch } from "react-redux";
import Popup from "../components/common/Popup";

const SignIn = () => {
  const dispatch = useDispatch();
  const [emailOrPhone, setEmailOrPhone] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({ emailOrPhone: "", password: "" });
  const [state, setState] = useState("normal");
  const [keep, setKeep] = useState(false);
  const [code, setCode] = useState("");
  const [checkPass, setCheckPass] = useState(false);
  const { t } = useTranslation();
  const [methodF2A, setMethodF2A] = useState("email");

  const [isPopupOpen2fa, setIsPopupOpen2fa] = useState(false);
  const closePopup = () => {
    setIsPopupOpen2fa(false);
    setMethodF2A("email");
  };

  const resetErrors = () => {
    // reset errors
    setErrors((prevErrors) => ({
      ...prevErrors,
      emailOrPhone: "",
      password: "",
    }));
    setState("normal");
  };

  const handleEmailChange = (e) => {
    // handle emailOrPhone change
    setEmailOrPhone(e.target.value);
    resetErrors();
  };

  const handleCodeChange = (e) => {
    // handle code change
    setCode(e.target.value);
    resetErrors();
  };

  const handlePasswordChange = (e) => {
    // handle password change
    setPassword(e.target.value);
    resetErrors();
  };

  const handleKeepSignedInChange = () => {
    // handle keep signed in change
    setKeep(!keep);
  };

  const handleSubmit = (e) => {
    // handle form submit
    e.preventDefault();
    fetchLogin({ emailOrPhone, password, keep, code, methodF2A }).then(
      (data) => {
        if (data.success) {
          updateUserInfo(dispatch, data.dataUser);
          console.log(data.dataUser);
        } else {
          setErrors((prevErrors) => ({
            ...prevErrors,
            password: "invalid email, phone number or password",
          }));
          setState("error");
        }
      }
    );

    console.log("Email:", emailOrPhone, "Password:", password);
  };

  const handleSubmit2fa = (e) => {
    // handle form submit
    const checkAtribute = e !== "phone" && e !== "email";

    if (checkAtribute) {
      e.preventDefault();
    }

    fetch2fa({ methodF2A: checkAtribute ? methodF2A : e, emailOrPhone, password }).then((data) => {
      if (data.success) {
        setIsPopupOpen2fa(true);
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          password: "invalid email, phone number or password",
        }));
        setState("error");
      }
    });

    console.log("Email:", emailOrPhone, "Password:", password);
  };

  return (
    <div className="sign-in">
      <Popup isOpen={isPopupOpen2fa} onClose={closePopup}>
        <form className="popup-content">
          <h3>{t("Additional security for your account")}</h3>
          <p className="popup-paragraf">
            {methodF2A === "email"
              ? t(
                  "Please enter the security code that was sent to your email"
                )
              : t(
                  "Please enter the security code that was sent to your phone"
                )}
          </p>
          <Input
            id="code"
            label={t("Security code")}
            type="text"
            value={code}
            onChange={handleCodeChange}
            placeholder={t("Enter code")}
            state={state}
            pattern=".*"
            required
          />
          <div style={{ width: "100%" }} className="flex-column">
            <button
              style={{ width: "100%" }}
              type="submit"
              onClick={handleSubmit}
              className="form-default__submit"
            >
              {t("Continue")}
            </button>
            {methodF2A === "email" ? (
              <button
                onClick={() => {
                  handleSubmit2fa("phone");
                  setMethodF2A("phone");
                }}
                type="button"
                className="form-default__link"
              >
                {t("Try again by Phone")}
              </button>
            ) : (
              <button
                onClick={() => {
                  handleSubmit2fa("email");
                  setMethodF2A("email");
                }}
                type="button"
                className="form-default__link"
              >
                {t("Try again by Email")}
              </button>
            )}
          </div>
        </form>
      </Popup>
      <h1 className="heading">{t("Welcome back")}</h1>
      <p className="to-sign-up">
        {t("Don’t have an account?")}{" "}
        <NavLink to={`/sign-up`}>{t("Sign Up")}</NavLink>
      </p>
      <form onSubmit={handleSubmit2fa}>
        <div className="form-default flex-column">
          <Input
            id="emailOrPhone"
            label={t("Email/Phone number")}
            type="text"
            value={emailOrPhone}
            onChange={handleEmailChange}
            placeholder={t("Enter email or phone number")}
            state={state}
            pattern=".*"
            required
          />

          <Input
            id="password"
            label={t("Password")}
            type="password"
            value={password}
            onChange={handlePasswordChange}
            placeholder={t("Enter password")}
            state={state}
            alertState={errors.password}
            required
            pattern=".*"
            isCheckPass={checkPass}
            checkPass={setCheckPass}
          />
        </div>

        <div className="sign-in-options">
          <Input
            id="keep"
            label={t("Keep me signed in")}
            type="checkbox"
            value={keep}
            onChange={handleKeepSignedInChange}
          />
          <NavLink to={`/forgot-password`}>{t("Forgot Password?")}</NavLink>
        </div>

        <button className="form-default__submit" type="submit">
          {t("Log In")}
        </button>
      </form>
    </div>
  );
};

export default SignIn;
